import React from 'react';
import {
  MapPin,
  Phone,
  Mail,
  Award,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: "Business Registration", route: "/services/business-registration" },
    { name: "VAT Filing", route: "/services/vat-filing" },
    { name: "Bookkeeping", route: "/services/bookkeeping" },
    { name: "Financial Consulting", route: "/services/financial-consulting" },
    { name: "Web Development", route: "/services/web-development" },
    { name: "Mobile Development", route: "/services/mobile-development" },
    { name: "Software Development", route: "/services/software-development" },
    { name: "Cybersecurity", route: "/services/cybersecurity" },
    { name: "AI Chatbots", route: "/services/ai-chatbot" },
    { name: "Multi-Agent AI", route: "/services/multi-agent-ai" },
    { name: "Machine Learning", route: "/services/machine-learning" },
    { name: "Computer Vision", route: "/services/computer-vision" },
    { name: "AI Search", route: "/services/ai-search" },
    { name: "AI Automation", route: "/services/ai-automation" }
  ];

  const products = [
    { name: "XivoHR Overview", route: "/xivohr", internal: true },
    { name: "XivoHR — HR & Payroll Software", href: "https://xivohr.com", internal: false },
    { name: "Get a Custom Quote", route: "/contact?demo=xivohr", internal: true },
  ];

  const quickLinks = [
    { name: "About Us", route: "/about" },
    { name: "Our Services", route: "/home#services" },
    { name: "Contact", route: "/contact" },
    { name: "Privacy Policy", route: "/privacyPolicy" },
    { name: "Terms of Service", route: "/terms" }
  ];

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">

          {/* Company Info */}
          <div className="footer__section company">
            <div className="company__title">
              RAPIDGOO
            </div>
            <div className="company__subtitle">UAE Licensed and Regulated</div>
            <p className="company__desc">
              Your trusted partner for comprehensive business and IT services in the UAE.
              Licensed and regulated in UAE.
            </p>

            <div className="company__license">
              <Award className="icon" />
              <span>Licensed & Regulated</span>
            </div>
          </div>

          {/* Services */}
          <div className="footer__section">
            <h3 className="footer__heading">Our Services</h3>
            <ul className="footer__list">
              {services.map((service, i) => (
                <li key={i}><Link to={service.route}>{service.name}</Link></li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div className="footer__section">
            <h3 className="footer__heading">Products</h3>
            <ul className="footer__list">
              {products.map((product, i) => (
                <li key={i}>
                  {product.internal ? (
                    <Link to={product.route}>{product.name}</Link>
                  ) : (
                    <a href={product.href} target="_blank" rel="noopener noreferrer">
                      {product.name} <span aria-hidden="true">↗</span>
                    </a>
                  )}
                </li>
              ))}
            </ul>

            <h3 className="footer__heading mt-4">Quick Links</h3>
            <ul className="footer__list">
              {quickLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.route}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer__section">
            <h3 className="footer__heading">Contact Info</h3>
            <div className="footer__contact">
              <div className="contact__item">
                <Phone className="icon" />
                <div>
                  <div>+971 50 871 3471</div>
                </div>
              </div>
              <div className="contact__item">
                <Mail className="icon" />
                <div>
                  <div>support@rapidgoo.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div>&copy; {currentYear} RapidGoo UAE. All rights reserved.</div>
          <div className="footer__links">
            <Link to="/privacyPolicy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
